export const environment = {
  production: true,
  apiUrl: 'https://staging.delivery-api.kasha.co',
  loginUrl: 'https://staging.cms.kasha.co/api/enterprise/login',
  auditLogUrl: 'https://staging.log-api.kasha.co/collect-log ',
  oneKashaLogUrl: 'https://staging.log-api.kasha.co/one-kasha-log',
  enableOneKashaLog: true,
  deliveryFormPageSize : 10,
  hivPDSID : 67,
  za_hivPDSID : 88,
  rw_ncdSanofiID : 105,
  rw_pdsID : 108,
  loginRedirectUrls: {
    hivPDSID: 'https://staging.hiv-pds-accessportal.kasha.co',
    za_hivPDSID: 'https://staging.za-hiv-pds-accessportal.kasha.co',
    rw_ncdSanofiID: 'https://staging.sanofi-ncd-accessportal.kasha.co',
    rw_pdsID: 'https://staging.pds-accessportal.kasha.rw'
  },
  checkTokenInterval : 60000
};